import {Plan} from "./plan";
import {SubsItems} from "./subscriptionItems";

export class StripeSubs {

  constructor(
    public  $key                      :string, //subscription ID
    public  cancel_at_period_end      :boolean,
    public  created                   :number,
    public  current_period_end        :number,
    public  current_period_start      :number,
    public  customer                  :string,
    public  id                        :string,
    public  items                     :SubsItems,
    public  livemode                  :boolean,
    public  plan                      :Plan,
    public  quantity                  :number,
    public  start                     :number,
    public  status                    :string,
    public  trial_end                 :number,
    public  trial_start               :number
  ){};

  static  fromJson({
                     $key,
                     cancel_at_period_end,
                     created,
                     current_period_end,
                     current_period_start,
                     customer,
                     id,
                     items,
                     livemode,
                     plan,
                     quantity,
                     start,
                     status,
                     trial_end,
                     trial_start
                   }): StripeSubs {
    return new StripeSubs(
      $key,
      cancel_at_period_end,
      created,
      current_period_end,
      current_period_start,
      customer,
      id,
      items,
      livemode,
      plan,
      quantity,
      start,
      status,
      trial_end,
      trial_start
    )}

}



// WEBPACK FOOTER //
// ./src/app/shared/model/stripe-subs.ts